import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

import error404 from '../assets/error_404.webp';

import '../utils/general.css';
import '../utils/error404.css';

import Seo from '../components/seo';

export default function Error404() {
  return (
    <Container className='ps-404' fluid>
      <Seo title="404 - Page not found" description="This page does not exist." noindex />
      <Row>
        <Col className='text-center pt-5'>
          <h1>Are you lost?</h1>
          <Image src={error404} roundedCircle loading="lazy" alt="Illustration Rick et Morty, page introuvable" />
          <p>Error 404</p>
        </Col>
      </Row>
    </Container>
  );
}
